import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A9TransactionsEdit } from "./edit";
import { A9TransactionsNew } from "./new";
import { A9TransactionsTable } from "./table";

export default function A9Transactions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Transactions");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A9TransactionsEdit />} />
      <Route index element={<A9TransactionsTable />} />
      <Route path="/new" element={<A9TransactionsNew />} />
    </Routes>
  );
}
